import { createWebHistory, createRouter } from "vue-router";
import AdminLayout from "./components/Layouts/AdminLayout.vue";
import AuthLayout from "./components/Layouts/AuthLayout.vue";


const routes = [
    {
        path: "",
        redirect: "/"
    },
    // {
    //     path: "/Anasayfa",
    //     beforeEnter(to, from, next) {
    //         window.location.replace("https://www.gelsinteknik.com")
    //     }
    // },
    { path: "/Blog_", redirect: "/Blog_/TumYazilar" },
    {
        path: "/Blog_",
        name: "",
        component: AdminLayout,
        children: [{
            path: "/Blog_/TumYazilar",
            name: "Blog_",
            component: () =>
                import("./components/YonetimSistemi/PrivatePage/Blog/TumYazilar.vue")
        },
        {
            path: "/Blog_/YeniYazi",
            name: "Blog_YeniYazi",
            component: () =>
                import("./components/YonetimSistemi/PrivatePage/Blog/YeniYazi.vue")
        },

        ]
    },

    { path: "/Auth", redirect: "/Auth/Login" },
    {
        path: "/Auth",
        name: "",
        component: AuthLayout,
        children: [{
            path: "/Auth/Login",
            name: "Login",
            component: () =>
                import("./components/YonetimSistemi/PublicPage/Auth/Login.vue"),
        }
        ]
    },
    { path: "/SifreIslemleri", redirect: "/SifreIslemleri/SifreUnuttum" },
    {
        path: "/SifreIslemleri/SifreYenile/:id",
        name: "",
        component: AuthLayout,
        children: [
            {
                path: "/SifreIslemleri/SifreUnuttum",
                name: "SifreUnuttum",
                component: () =>
                    import("./components/YonetimSistemi/PublicPage/SifreIslemleri/SifreUnuttum.vue")
            },
            {
                path: "/SifreIslemleri/SifreYenile",
                name: "SifreYenile",
                component: () =>
                    import("./components/YonetimSistemi/PublicPage/SifreIslemleri/SifreYenile.vue")
            }
        ]
    },

    { path: "/Admin", redirect: "/Admin/Main" },
    {
        path: "/Admin",
        name: "",
        component: AdminLayout,
        children: [{
            path: "/Admin/Main",
            name: "Main",
            component: () =>
                import("./components/YonetimSistemi/PrivatePage/AdminSayfalari/AdminSayfasi.vue")
        },
        ]
    },
    { path: "/Kullanici", redirect: "/Kullanici/Ayarlar" },
    {
        path: "/Kullanici",
        name: "",
        component: AdminLayout,
        children: [{
            path: "/Kullanici/Ayarlar",
            name: "Kullanici",
            component: () =>
                import("./components/YonetimSistemi/PrivatePage/KullaniciAyarlari/Ayarlar.vue")
        },
        ]
    },
    { path: "/Yonetim", redirect: "/Yonetim/Rol/Rol" },
    {
        path: "/Yonetim",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Yonetim/Kullanicilar",
                name: "Kullanicilar",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/KullaniciSayfalari/KullanicilarSayfasi.vue")
            },
            {
                path: "/Yonetim/Rol/Rol",
                name: "Rol",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/Rol/Rol.vue")
            },
            {
                path: "/Yonetim/RolYetki",
                name: "RolYetki",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/Rol/RolYetki.vue")
            },
            {
                path: "/Yonetim/Yetki",
                name: "Yetki",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/Yetki/Yetki.vue")
            },
            {
                path: "/Yonetim/WebSayfa",
                name: "WebSayfa",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/Yetki/WebSayfa.vue")
            },
            {
                path: "/Yonetim/Sistem/TabloBoyut",
                name: "TabloBoyut",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Yönetim/Sistem/TabloBoyut.vue")
            },
        ]
    },
    { path: "/Musteri", redirect: "/Musteri/MusteriListesi" },
    {
        path: "/Musteri/:MusteriNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Musteri/MusteriListesi",
                name: "MusteriListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Musteri/Musteri/MusteriListesi.vue")
            },
            {
                path: "/Musteri/YeniMusteri",
                name: "MusteriTanimla",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Musteri/Musteri/YeniMusteri.vue")
            },
            {
                path: "/Musteri/DuzenleMusteri",
                name: "DuzenleMusteri2",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Musteri/Musteri/DuzenleMusteri.vue")
            },
        ]
    },
    { path: "/Urun", redirect: "/Urun/UrunListesi" },
    {
        path: "/Urun/:UrunNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Urun/UrunListesi",
                name: "UrunListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Urun/UrunListesi.vue")
            },
            {
                path: "/Urun/YeniUrun",
                name: "UrunYeni",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Urun/YeniUrun.vue")
            },
            {
                path: "/Urun/DuzenleUrun",
                name: "UrunDuzenle",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Urun/DuzenleUrun.vue")
            },

        ]
    },

    // Satis
    { path: "/Islemler", redirect: "/Islemler/MalzemeGiris" },
    {
        path: "/Islemler",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Islemler/Satis",
                name: "Satis",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Islemler/Satis.vue")
            },
        ]
    },
    // Diyetisyen
    { path: "/Diyetisyen", redirect: "/Diyetisyen/Dashboard" },
    {
        path: "/Diyetisyen/Dashboard",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Diyetisyen/Dashboard",
                name: "DiyetisyenDashboard",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Dashboard/Dashboard.vue")
            },
        ]
    },
    { path: "/Diyetisyen", redirect: "/Diyetisyen/Danisan" },
    {
        path: "/Diyetisyen/:DanisanNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Diyetisyen/DanisanListesi",
                name: "DiyetisyenDanisanListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Danisan/DanisanListesi.vue")
            },
            {
                path: "/Diyetisyen/DetayDanisan",
                name: "DetayDanisan",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Danisan/DetayDanisan.vue")
            },
            {
                path: "/Diyetisyen/ExportDiyet",
                name: "ExportDiyet",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Danisan/DetayDanisman/DiyetDetay/ExportDiyet.vue")
            },
            
        ]
    },
    { path: "/Diyetisyen", redirect: "/Diyetisyen/TarifListesi" },
    {
        path: "/Diyetisyen/:TarifNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Diyetisyen/TarifListesi",
                name: "TarifListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Tarif/TarifListesi.vue")
            },
            {
                path: "/Diyetisyen/YeniTarif",
                name: "YeniTarif",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Tarif/YeniTarif.vue")
            },
            {
                path: "/Diyetisyen/DuzenleTarif",
                name: "DuzenleTarif",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Tarif/DuzenleTarif.vue")
            },
        ]
    },
    { path: "/Diyetisyen", redirect: "/Diyetisyen/OgunListesi" },
    {
        path: "/Diyetisyen/:OgunNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Diyetisyen/OgunListesi",
                name: "OgunListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Ogun/OgunListesi.vue")
            },
            {
                path: "/Diyetisyen/YeniOgun",
                name: "YeniOgun",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Ogun/YeniOgun.vue")
            },
            {
                path: "/Diyetisyen/DuzenleOgun",
                name: "DuzenleOgun",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/Ogun/DuzenleOgun.vue")
            },
        ]
    },
    { path: "/Diyetisyen", redirect: "/Diyetisyen/DiyetTanimListesi" },
    {
        path: "/Diyetisyen/:DiyetNo",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Diyetisyen/DiyetTanimListesi",
                name: "DiyetListesi",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/DiyetTanim/DiyetTanimListesi.vue")
            },
            {
                path: "/Diyetisyen/YeniDiyetTanim",
                name: "YeniDiyet",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/DiyetTanim/YeniDiyetTanim.vue")
            },
            {
                path: "/Diyetisyen/DuzenleDiyetTanim",
                name: "DuzenleDiyet",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Diyetisyen/DiyetTanim/DuzenleDiyetTanim.vue")
            },
        ]
    },
    { path: "/Tanimlamalar", redirect: "/Tanimlamalar/Kategori" },
    {
        path: "/Tanimlamalar",
        name: "",
        component: AdminLayout,
        children: [
            {
                path: "/Tanimlamalar/Kategori",
                name: "KategoriTanim",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Kategori.vue")
            },
            {
                path: "/Tanimlamalar/AltKategori",
                name: "AltKategoriTanim",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/AltKategori.vue")
            },
            {
                path: "/Tanimlamalar/Birim",
                name: "BirimTanim",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Birim.vue")
            },
            {
                path: "/Tanimlamalar/Karakteristik",
                name: "KarakteristikTanim",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Karakteristik.vue")
            },
            {
                path: "/Tanimlamalar/Grup",
                name: "GrupTanim",
                component: () =>
                    import("./components/YonetimSistemi/PrivatePage/Tanimlamalar/Grup.vue")
            },

        ]
    },


    // {
    //     path: "/:catchAll(.*)",
    //     component: () =>
    //         import("./components/YonetimSistemi/PublicPage/ErrorPages/NotFound.vue"),
    // },
    {
        path: "/Hata_ErisimYetkisi",
        component: () =>
            import("./components/HataSayfalari/Hata_ErisimYetkisi.vue"),
    },
    {
        path: "/OturumSuresiBitti",
        component: () =>
            import("./components/HataSayfalari/OturumSuresiBitti.vue"),
    },
    {
        path: "/NotFound",
        component: () =>
            import("./components/HataSayfalari/NotFound.vue"),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

import GlobalServis from '../src/services/GlobalServis';
import index from './store/index';

router.beforeEach((to, from, next) => {
    if (
        to.href.toLowerCase() == '/anasayfa' ||
        to.href.toLowerCase() == "/auth/login" ||
        to.href.toLowerCase().match(/sifreislemleri*/) ||
        to.href.toLowerCase() == "/notfound" || to.href.toLowerCase() == "/hata_erisimyetkisi" || to.href.toLowerCase() == "/oturumsuresibitti"
    ) {
        next();
    } else {
        let data = {
            URL: to.href
        }
        GlobalServis.GlobalServis("POST", "GetYetkiKontrol", data).then(
            (res) => {
                if (res.status == 200 && res.data == true) {
                    next();
                } else if(res.status == 400) {
                    next('/Hata_ErisimYetkisi');
                }
                else {

                    if (typeof (res.response) !== "undefined") {
                        if (res.response.status === 999) {
                            next('/Hata_ErisimYetkisi');
                        }
                    }

                    if (res.data == false) {
                        next('/Hata_ErisimYetkisi');
                    }

                    if (index.state.auth.status.loggedIn) {
                        next('/NotFound');
                    } else {
                        next();
                    }
                }
            }
        );
    }
})

router.afterEach(() => {
})

export default router;